import React, { useContext, useState } from "react";
import { useField } from "react-final-form";
import { IntlContext } from "context";
import { useResendEmailValidation } from "hooks/authentication";
import { toast } from "sonner";

const AccountValidationMessage: React.FC = () => {
    const intl = useContext(IntlContext);
    const accountValidationError = useField("account_validation").meta.submitError?.props?.error;
    const email = useField("username");
    const [isClicked, setIsClicked] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isSent, setIsSent] = useState(false);
    const resendEmailValidationMutation = useResendEmailValidation();

    const onResend = async () => {
        try {
            setIsClicked(true);
            setIsLoading(true);
            await resendEmailValidationMutation.mutateAsync(email.input.value);
            toast.success(intl.formatMessage("authentication.login.action.resend_mail_activate"));
            setIsLoading(false);
            setIsSent(true);
        } catch {
            setIsClicked(false);
            setIsLoading(false);
        }
    };

    if (!accountValidationError) return null;

    return (
        <>
            <div role="alert">
                <span>{intl.formatMessage("validation.account_validation")}</span>
                <br />
                {isLoading && <span className="ml-1 animate-pulse">…</span>}
                {!isClicked && (
                    <span>
                        <button type="button" className="underline" onClick={onResend}>
                            {intl.formatMessage("validation.account_validation.resend.click")}
                        </button>{" "}
                        {intl.formatMessage("validation.account_validation.resend")}
                    </span>
                )}
            </div>
            {isSent && (
                <p aria-live="polite" className="mt-1 text-sm text-green-600">
                    L&apos;e-mail d&apos;activation vous a été renvoyé !
                </p>
            )}
        </>
    );
};

export default AccountValidationMessage;
